import SpesOrder from '@/router/SpesOrder'

const routes = [...SpesOrder]

export default routes
